/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Heading, Stack, Text, FontAwesomeIcon } from "components";
import applySuffix from "utils/applySuffix";
import { useTranslation } from "react-i18next";
const CompanionSection = ({ companions }) => {
  const { t } = useTranslation();
  return (
    <Stack className="gap-y-4">
      <Heading as="h3" className="text-xl -text--theme-colors-text-title-brand">
        {t("companionSection.companionsLabel")}
      </Heading>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-10 gap-y-5">
        {companions.map((companion, i) => (
          <Companion key={i} companion={companion} number={i + 1} />
        ))}
      </div>
    </Stack>
  );
};

const Companion = ({ companion, number }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-x-2.5 items-center">
      <div className="-text--theme-colors-icon-primary">
        <FontAwesomeIcon name="fa-user" size="xl" />
      </div>
      <div className="flex flex-col">
        <Text className="-text--theme-colors-text-caption">
          {applySuffix(number)}
        </Text>
        <Text className="-text--theme-colors-text-body">
          {t("companionSection.companionLabel")}
        </Text>
        <Text className="-text--theme-colors-text-body">
          {companion?.first_name} {companion?.last_name}
        </Text>
      </div>
    </div>
  );
};

export default CompanionSection;
